export default "__VITE_ASSET__9c4c6148__"